import React, { useState, useEffect } from "react";
import { blue } from "@mui/material/colors";
import ReactMarkdown from "react-markdown";
import dayjs from "dayjs";
import DatePicker from "@mui/lab/DatePicker";
// components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Toolbar from "@mui/material/Toolbar";

import LinearProgress from "@mui/material/LinearProgress";
import api, { PagenatedRequest } from "../../../../api/medAppApi";

import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ClearIcon from "@mui/icons-material/Clear";
// import AppLink from '../../components/AppLink';

//others
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { putMessage } from "../../../app/store/actions";

import { ActivityTrail } from "../../../../models";
import { ROUTES } from "../../../../history";

const ActivityPage = () => {
  const dispatch = useDispatch();
  const [activityTrail, setActivityTrail] = useState<ActivityTrail[]>([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [rows, setRows] = useState(0);
  const [from, setFrom] = React.useState<Date | null>(null);

  const [to, setTo] = React.useState<Date | null>(new Date());

  useEffect(() => {
    if (from !== null && to !== null) {
      console.log([from, to]);
      let f = from.getTime();
      let t = to.getTime();
      if (t > f) {
        setPage(1);
      }
    } else if (from === null && to === null) {
      setPage(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [from, to]);

  const loadMore = React.useCallback(
    async () => {
      let ans;
      let current = page;

      let crieteria: any = {};

      if (!!from && !!to) {
        crieteria = {
          and: [
            { createdAt: { ">=": from.getTime() } },
            { createdAt: { "<=": to.getTime() } },
          ],
        };
      }
      let search: PagenatedRequest = {
        modelName: "activity",
        returnType: "list",
        crieteria,
        limit: 20,
        page: current,
      };
      ans = await api.getModelList<ActivityTrail>(search);

      return ans.data;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [page, to, from]
  );

  const { data, isFetching, refetch, isError } = useQuery(
    "load-activity",
    loadMore
  );

  const loader = <LinearProgress />;


  React.useEffect(() => {
    if (isFetching) return;
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [page]);

React.useEffect(() => {
    if(isError) {
     dispatch(putMessage({type: 'error', message: 'Failed to load appointments'}))
 }},
 // eslint-disable-next-line react-hooks/exhaustive-deps
  [isError]);

  React.useEffect(() => {
    if (!data) return;
    let ans = data!.data;
    if (ans) {
        setActivityTrail(ans.payload);
        setTotal(ans.total);
        setRows(ans.rows);
    }
}, [data]);

  const body = (
    <Box
      sx={{
        p: 2,
      }}
    >
      <Toolbar
        sx={{
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        }}
      >
        <Box display="flex" sx={{ flex: "1 1 100%" }} alignItems={"center"}>
          <IconButton
            disabled={page === 1}
            onClick={() => {
              setPage(page - 1);
            }}
          >
            <ChevronLeftIcon />
          </IconButton>
          <Typography id="tableTitle" fontSize={"12px"}>
            {(page - 1) * 20 + 1} to {page * 20 > total ? total : page * 20} of{" "}
            {total}
          </Typography>
          <IconButton
            disabled={page === rows}
            onClick={() => {
              setPage(page + 1);
            }}
          >
            <ChevronRightIcon />
          </IconButton>
        </Box>
        <Box
          sx={{
            display: {
              md: "flex",
              sm: "block",
            },
          }}
        >
          <DatePicker
            label="From"
            value={from}
            InputProps={{
              sx: {
                mr: 2,
              },
            }}
            onChange={(newValue: any) => {
              try {
                if (newValue == null) {
                  setFrom(newValue);
                }
                if (newValue.$d) setFrom(newValue.$d);
                else setFrom(newValue);
              } catch (err) {
                setFrom(newValue);
              }
            }}
            renderInput={(params) => <TextField {...params} />}
          />
          <Box
            sx={{
              mt: {
                sm: 2,
                xs: 2,
                md: 0,
              },
            }}
          >
            <DatePicker
              InputProps={{
                sx: {
                  mr: 2,
                },
              }}
              label="To"
              value={to}
              onChange={(newValue: any) => {
                try {
                  if (newValue.$d) {
                    setTo(newValue.$d);
                  } else setTo(newValue);
                } catch (err) {
                  setTo(newValue);
                }
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </Box>

          <IconButton
            onClick={() => {
              setFrom(null);
              setTo(null);
              // setPage(1);
              // loadMore(1);
            }}
          >
            <ClearIcon />
          </IconButton>
        </Box>
      </Toolbar>
      <div
        style={{
          fontFamily: "Lato, sans-serif",
          width: "90%",
          padding: "1em 0 1em 1em",
          fontSize: "14px",

          borderLeft: "2px solid " + blue[500],
        }}
      >
        {activityTrail.map((activity, index) => (
          <Box
            key={"dashboard-activity-" + index}
            sx={{
              position: "relative",
              "& a": {
                textDecoration: "none",
              },
              "&::before": {
                content: "' '",
                position: "absolute",
                left: "-24px",
                height: "18px",
                width: "18px",
                backgroundColor: blue[500],
                borderRadius: "9px",
              },
            }}
          >
            <ReactMarkdown linkTarget={"_blank"} transformLinkUri={(href) => `${ROUTES.ADMIN_BASE}${href}`}>
              {activity.description || "**Error**"}
            </ReactMarkdown>
            <small>{dayjs(activity.createdAt).format("MMM D")}</small>
          </Box>
        ))}
      </div>
    </Box>
  );

  return (
    <Box>
      {isFetching && loader}
      <Paper elevation={0}>{body}</Paper>
    </Box>
  );
};

export default ActivityPage;
